'use client';

import { SelectHTMLAttributes, forwardRef } from 'react';
import styles from './Input.module.css'; // Reuse Input styles for consistency

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    error?: string;
    hint?: string;
    options?: { value: string | number; label: string }[];
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ label, error, hint, className = '', id, children, options, ...props }, ref) => {
        const selectId = id || `select-${Math.random().toString(36).slice(2, 9)}`;

        return (
            <div className={styles.formGroup}>
                {label && (
                    <label htmlFor={selectId} className={styles.label}>
                        <span className={styles.dimText}>// </span>
                        {label}
                        {props.required && <span className={styles.required}> *</span>}
                    </label>
                )}
                <div className={styles.selectWrapper}>
                    <select
                        ref={ref}
                        id={selectId}
                        className={`${styles.input} ${styles.select} ${error ? styles.inputError : ''} ${className}`}
                        {...props}
                    >
                        {options
                            ? options.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))
                            : children}
                    </select>
                </div>
                {hint && !error && <span className={styles.hint}>{hint}</span>}
                {error && <span className={styles.error}>{error}</span>}
            </div>
        );
    }
);

Select.displayName = 'Select';

export default Select;
